import { useEffect, useRef } from "react";
import { Activity, LockKeyhole, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export default function LoginView() {
  const { signInWithGoogle, authError } = useAuth();
  const buttonRef = useRef(null);
  const callbackRef = useRef(signInWithGoogle);
  callbackRef.current = signInWithGoogle;

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    let cancelled = false;
    const initialize = () => {
      if (cancelled || !window.google || !buttonRef.current) return;
      window.google.accounts.id.initialize({ client_id: GOOGLE_CLIENT_ID, callback: ({ credential }) => callbackRef.current(credential) });
      buttonRef.current.innerHTML = "";
      window.google.accounts.id.renderButton(buttonRef.current, { theme: "filled_black", size: "large", width: 320, shape: "rectangular", text: "signin_with" });
    };
    let script = document.querySelector('script[data-aura-gis="true"]');
    if (window.google?.accounts?.id) initialize();
    else if (script) script.addEventListener("load", initialize);
    else {
      script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.dataset.auraGis = "true";
      script.addEventListener("load", initialize);
      document.head.appendChild(script);
    }
    return () => {
      cancelled = true;
      script?.removeEventListener("load", initialize);
    };
  }, []);

  return (
    <main className="login-page">
      <div className="login-scanlines" />
      <section className="login-brand" data-testid="login-brand-panel">
        <div className="brand-lockup"><span><Activity /></span><strong>AuraLive</strong></div>
        <div className="login-message"><span className="overline">Production command</span><h1>Clarity when every action matters.</h1><p>Monitor live activity, resolve reports, and protect the AuraLive community from one controlled workspace.</p></div>
        <div className="security-caption"><ShieldCheck size={18} /><span>Role-gated access</span><i /><span>Encrypted session</span></div>
      </section>
      <section className="login-access" data-testid="login-access-panel">
        <div className="access-card">
          <div className="access-icon"><LockKeyhole /></div>
          <span className="overline">Restricted system</span>
          <h2>Admin access</h2>
          <p>Continue with an authorized moderator or super admin Google account.</p>
          <div ref={buttonRef} className="google-button-slot" data-testid="google-signin-button-container" />
          {authError && <div className="auth-error" role="alert" data-testid="login-error-message">{authError}</div>}
          <small data-testid="login-security-note">Access attempts are recorded in the audit trail.</small>
        </div>
      </section>
    </main>
  );
}